import styled from "styled-components";
import { Colors } from "../../../shared/colors/colors";
import { Fonts } from "../../../shared/fonts/fonts";
import { StyledButton } from "../../../components/Button/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 0;
  gap: 20px;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  border: 1px solid ${Colors.borderInput};
  border-radius: 8px;
  background-color: ${Colors.white};
`;

export const SearchIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.inputIcon};
  z-index: 1;
  padding-left: 19px;
  padding-right: 12px;
`;

export const SearchInput = styled.input`
  height: 48px;
  padding: 12px 12px 12px 0;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  flex: 1;
  width: 100%;
  line-height: 24px;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: ${Colors.placeholder};
    font-size: 14px;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const YearSelect = styled.select`
  height: 40px;
  padding: 0 15px;
  border: 1px solid ${Colors.borderInput};
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  min-width: 150px;
  appearance: auto;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${Colors.primary};
  }
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: ${Colors.label};
  display: block;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  font-family: ${Fonts.primary};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  justify-content: center;
  border-radius: 8px;
  max-height: 51px;
  color: ${Colors.white};
  background-color: ${Colors.primary};
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;

  &:hover {
    background-color: #1a4fb1;
  }
`;

// Novo botão para ações de sucesso/download com o mesmo padrão dos StyledButton
export const SuccessButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  font-family: ${Fonts.primary};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  justify-content: center;
  border-radius: 8px;
  max-height: 51px;
  max-width: fit-content;
  transition: background-color 0.3s, color 0.3s;
  white-space: nowrap;
  border: none;
  
  background-color: ${props => props.disabled ? Colors.disabled : Colors.success};
  color: ${Colors.white};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.7 : 1};
  
  &:hover {
    background-color: ${props => props.disabled ? Colors.disabled : '#1e7e34'};
  }
`;

// Estilos para o Modal de Pendências
// export const Overlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: rgba(0, 0, 0, 0.7);
//   z-index: 5000;
//   display: none;
//   justify-content: center;
//   align-items: center;
//   overflow-y: auto;
  
//   &.active {
//     display: flex;
//   }
// `;

// export const ModalContainer = styled.div`
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   background: white;
//   width: 55rem;
//   height: fit-content;
//   border-radius: 4px;
//   padding: 32px;
// `;

// export const ModalTitle = styled.h1`
//   font-size: 16px;
//   line-height: 20px;
//   letter-spacing: 0.4px;
//   color: #4b5563;
// `;

export const Divider = styled.div`
  width: 100%;
  border: 1px solid rgba(229, 231, 235, 1);
`;

export const RowFilter = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  flex-wrap: nowrap;
  margin-top: 20px;
`;

export const ColumnFilter = styled.div`
  flex: 1;
  max-width: calc(50% - 8px);
`;

export const FullColumnFilter = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const FilterForm = styled.form`
  margin-top: 16px;
  margin-left: 0;
`;

export const FormControl = styled.input`
  max-width: 100%;
  height: 48px;
  border-radius: 8px;
  border: 1px solid #afb1b6;
  padding: 12px;
  gap: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  width: 100%;
  
  &::placeholder {
    color: #9CA3AF;
  }
`;

export const FiltroLabel = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 5px;
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 30px;
  right: 28px;
`;

export const CloseButton = styled.button`
  background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e") center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  cursor: pointer;
  
  &:hover {
    opacity: 0.75;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ParcelaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px;
  background-color: white;
`;

export const ParcelaItem = styled.div`
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  border: 1px solid #e0e0e0;
  margin: 2px 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const InstructionText = styled.p`
  color: #333;
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 500;
  
`;

export const CancelButton = styled.button`
  padding: 10px 24px;
  background-color: white;
  color: ${Colors.primary};
  border: 1px solid ${Colors.primary};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  min-width: 120px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${Colors.primary};
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(37, 99, 235, 0.8);
  }

  svg {
    font-size: 16px;
  }
`;

export const FilterModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

// Alias para manter compatibilidade com o componente principal
export const ModalOverlay = FilterModalOverlay;

export const FilterModalContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

export const FilterModalTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 20px;
  color: ${Colors.fontColorTable};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FilterModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: ${Colors.fontColorTable};
  padding: 0;
`;

export const FilterGroup = styled.div`
  margin-bottom: 15px;
`;

export const FilterStatusOptions = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
`;

export const FilterStatusOption = styled.div`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
  &.selected {
    background-color: ${Colors.primary};
    color: white;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
`;

export const FilterFieldContainer = styled.div`
  flex: 1;
`;

export const YearInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
`;

export const FilterActionButton = styled.button`
  background-color: ${Colors.primary};
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  width: 100%;
  margin-top: 15px;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(37, 99, 235, 0.8);
  }
`;

// Componente para padronizar ícones nos botões
export const ButtonIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

// Botão para ações dentro da tabela - tamanho mais compacto
export const TableActionButton = styled(ActionButton)`
  padding: 8px 12px;
  max-height: 36px;
  font-size: 13px;
  white-space: nowrap;
`;

// Componentes para a seção de filtros aplicados
export const AppliedFiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  min-height: 48px;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 1);
  background: rgba(249, 250, 251, 1);
  box-sizing: border-box;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(107, 114, 128, 1);
`;

export const FilterTitle = styled.p`
  margin: 0;
  white-space: nowrap;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  border: 2px solid rgba(147, 197, 253, 1);
  border-radius: 4px;
  padding: 4px 8px;
  background-color: rgba(239, 246, 255, 1);
`;

export const FilterKey = styled.span`
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const FilterValue = styled.span`
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;

export const FilterRemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 0 5px;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #dc3545;
  }
`;


export const ContainerFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerButtons = styled.div`
  display: flex;
  gap: 10px;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 90vw;
  flex-direction: column;
  height: 100%;
  gap: 16px;
  margin-top: 16px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
